<table class="table table-striped" data-test="reportBuildingRoadmapTable">
  <thead>
    <tr>
      <th>{{ translationKey('measure.planned') | translate }}</th>
      @for (year of years(); track $index) {
        <th [style.width]="(year.year === '2030-35' ? 10 : 70 / years().length) + '%'">
          <div>
            {{ year.year ? year.year : (translationKey('noYear') | translate) }}
            @if (year.year && year.improvedEnergyLabel) {
              <cfp-energy-label [energyLabel]="year.improvedEnergyLabel" [size]="'xs'" class="d-flex-inline ms-2" />
            }
          </div>
        </th>
      }
    </tr>
  </thead>
  <tbody>
    @for (measure of plannedMeasures(); track $index) {
      <tr [attr.data-test]="`reportBuildingRoadmapTableRow_${measure.measureCode}`">
        <td>
          {{ measure.measureName || (`measure.name.${measure.measureCode}` | translate) }}
        </td>
        @for (year of years(); track $index) {
          <td class="text-end">
            @if (measure.year === year.year) {
              {{ measure.investment | cfpCurrency: portfolioBuildingsRoadmap().currencyCode }}
              @if (measure.isUserDefined) {
                <cfp-icon [icon]="'pen-circle'" />
              }
            }
          </td>
        }
      </tr>
    }
  </tbody>
  @if (totalInvestments()) {
    <tfoot>
      <tr>
        <th>
          <strong>{{ 'roadmap.total.investment' | translate }}</strong>
        </th>
        @for (investment of totalInvestments(); track $index) {
          <th class="text-end">
            @if (investment) {
              <strong>{{ investment | cfpCurrency: portfolioBuildingsRoadmap().currencyCode }}</strong>
            }
          </th>
        }
      </tr>
    </tfoot>
  }
</table>
